export default __webpack_public_path__ + "static/media/Border (4).299d2b2a.svg";